import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';

import { twclsx } from 'utils/twclsx';

import Image from './Image';

interface LoaderSpinnerProps {
    variant?: 'page' | 'button' | 'table';
    size?: 'small' | 'large';
    className?: string;
    children?: ReactNode;
}

class LoaderSpinner extends Component<LoaderSpinnerProps> {
    render() {
        const { variant = 'page', size = 'large', className, children } = this.props;

        let containerClasses = 'inline-block';
        switch (variant) {
            case 'page':
                containerClasses = 'absolute top-0 left-0 w-full h-full';
                break;
            case 'table':
                containerClasses = 'my-20';
                break;
            default:
                break;
        }

        const spinnerClasses = size === 'small' ? 'w-3 ' : 'w-5 ';

        return (
            <div className={twclsx('flex items-center justify-center', containerClasses, className)}>
                <Image alt="loading" className={twclsx('mx-2', spinnerClasses)} src="/static/images/loading.svg" />{' '}
                {children}
            </div>
        );
    }
}

const loaderSpinnerStateToProps = () => ({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loaderSpinnerDispatchToProps = () => ({});

export default connect(loaderSpinnerStateToProps, loaderSpinnerDispatchToProps)(LoaderSpinner);
